import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"
import { useRoadQuery } from "../../../../../common/hooks/queries/useRoadQuery"

import { networkGradingsQueryKeys } from "./queryKeys"

export function useRelevantNetworkGradings(project, queryParameters, config = {}) {
    const url = "network_gradings/"

    const parameters = useExtendWithSubnetworks({
        ...queryParameters,
        project: project,
    }, API_MODULE_ROADWAY)
    const { enabled = true } = config
    const queryKey = networkGradingsQueryKeys["listRelevants"](parameters)

    const { isLoading, isError, data, error } = useRoadQuery(
        url,
        queryKey,
        parameters,
        {
            ...config,
            enabled: !!project && enabled,
        },
    )

    const sortedRelevantNetworkGradings = data?.sort((ngA, ngB) => {
        return ngA.year - ngB.year
    })

    return { isLoading, isError, sortedRelevantNetworkGradings, error }
}